import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class RoutesActions {
    static FETCH_ALL_STOPS_WITH_ROUTES = '[Schedule]: Fetch stops with routes';
    static FETCH_ALL_STOPS_WITH_ROUTES_SUCCESS = '[Schedule]: Fetch stops with routes successful';
    static FETCH_ALL_STOPS_WITH_ROUTES_FAIL = '[Schedule]: Fetch stops with routes failed';

    static FETCH_ALL_ROUTES = '[Schedule]: Fetch all routes';
    static FETCH_ALL_ROUTES_SUCCESS = '[Schedule]: Fetch all routes successful';
    static FETCH_ALL_ROUTES_FAIL = '[Schedule]: Fetch all routes failed';

    static SET_SELECTED_ROUTE_ID = '[Schedule]: Set selected route id';

    fetchAllStopsWithRoutes(): RidangoReduxAction {
        return {
            type: RoutesActions.FETCH_ALL_STOPS_WITH_ROUTES,
        };
    }

    fetchAllStopsWithRoutesSuccess() {
        return {
            type: RoutesActions.FETCH_ALL_STOPS_WITH_ROUTES_SUCCESS,
        };
    }

    fetchAllStopsWithRoutesFail() {
        return {
            type: RoutesActions.FETCH_ALL_STOPS_WITH_ROUTES_FAIL,
        };
    }

    fetchAllRoutes(): RidangoReduxAction {
        return {
            type: RoutesActions.FETCH_ALL_ROUTES,
        };
    }

    fetchAllRoutesSuccess(payload) {
        return {
            type: RoutesActions.FETCH_ALL_ROUTES_SUCCESS,
            payload: payload,
        };
    }

    fetchAllRoutesFail() {
        return {
            type: RoutesActions.FETCH_ALL_ROUTES_FAIL,
        };
    }

    setSelectedRouteId(routeId: number): RidangoReduxAction {
        return {
            type: RoutesActions.SET_SELECTED_ROUTE_ID,
            payload: routeId,
        };
    }

}
